module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "footer"
  }, [_c('footer', [_c('a', {
    staticClass: "footer-href",
    attrs: {
      "href": "/dmca"
    }
  }, [_vm._v("DMCA & Copyright")]), _c('a', {
    staticClass: "footer-href",
    attrs: {
      "href": "/toc"
    }
  }, [_vm._v("Terms & Conditions")]), _c('br'), _vm._v(" "), _c('p', [_vm._v("\n      All the files uploaded on FilesBeast.net are free to use and distribute. FilesBeast.net does not own any of the files uploaded. The uploaded files belong to their rightful owners.\n\n      "), _c('br'), _c('br'), _vm._v("© 2017 FilesBeast.net. All rights reserved.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-ad734e7c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/layout/FooterBar.vue
// module id = 166
// module chunks = 34